import React from 'react';
import styled from 'styled-components';
import { Paper } from '@mediahuis/chameleon-react';
var Wrapper = styled(Paper).withConfig({
  displayName: "AboPaper__Wrapper",
  componentId: "sc-5wtgjd-0"
})(["margin:0 auto;max-width:100%;font-family:var(--font-family-system);@media (max-width:768px){padding:0px;border:none;box-shadow:none;}"]);

var AboPaper = function AboPaper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Wrapper, {
    width: "768px",
    p: 8
  }, children);
};

export default AboPaper;